import React from "react";
import { Route, Routes } from "react-router-dom";
import LoanLayout from "./LoanLayout";
import ScrollToTop from "./components/ScrollTop";
import CIBILRequest from "./pages/cibil/CIBILRequest";
import BureauScoreDisplay from './pages/cibil/BureauScoreDisplay';
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Counselling from "./components/Counselling";
import ApplyForLoan from "./pages/ApplyForLoan";
import ShortLoan from "./pages/ShortLoan";
import InstantLoan from "./pages/InstantLoan";
import FAQ from "./pages/FAQ";
import RateandTerms from "./pages/RateandTerms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsandConditions from "./pages/TermsandConditions";
import Ahmedabad from "./pages/locations/Ahmedabad";
import Hyderabad from "./pages/locations/Hyderabad";
import Mumbai from "./pages/locations/Mumbai";
import Banglore from "./pages/locations/Banglore";
import Delhi from "./pages/locations/Delhi";
import RepayLoan from "./pages/RepayLoan";
import Flexibility from "./pages/Flexibility";
import DebtConsolidation from "./pages/DebtConsolidation";
import MinimalCommitment from "./pages/MinimalCommitment";
import CostEffective from "./pages/CostEffective";
import Home from "./pages/Home";
import DashBoard from "./pages/Dashboard/DashBoard";
import PanDetails from "./pages/Dashboard/PanDetails/PanDetails";
import CapturAddress from "./pages/Dashboard/CapturAddress/CapturAddress";
import CapturPersonalInformation from "./pages/Dashboard/CapturPersonalInformation/CapturPersonalInformation";
import CapturIncomeDetails from "./pages/Dashboard/CapturIncomeDetails/CapturIncomeDetails";
import UploadPicture from "./pages/Dashboard/UploadPicture/UploadPicture";
import ReferenceDetails from "./pages/Dashboard/ReferenceDetails/ReferemceDetails";
import ReportsDetails from "./pages/admin/ReportsDetails";
import ProfilePage from "./pages/Dashboard/ProfilePage/ProfilePage";
import ProfilePreview from "./pages/Dashboard/ProfilePage/ProfilePreview";
import CalculateLoan from "./pages/Dashboard/CalculateLoan/CalculateLoan";
import AboutCompany from "./pages/Dashboard/AboutCompany/AboutCompany";
import Ekyc from "./pages/Dashboard/Ekyc/Ekyc";
import UploadBankStatement from "./pages/Dashboard/UploadBankStatement/UploadBankStatement";
import AccountAggregator from "./pages/Dashboard/AccountAggregator/AccountAggregator";
import Eligibility from "./pages/Dashboard/Eligibility/Eligibility";
import ProtectedRoute from "./components/ProtectedRoute";
import PanUpload from "./pages/Dashboard/PanUpload/PanUpload";
import DocumentUpload from "./pages/Dashboard/DocumentUpload/DocumentUpload";
import ThankYou from "./pages/Dashboard/ThankYou/ThankYou";
import UploadSalaryslip from "./pages/Dashboard/UploadSalaryslip/UploadSalaryslip";
import UploadUtilitybill from "./pages/Dashboard/UploadUtilitybill/UploadUtilitybill";
import LeadPreview from "./pages/Dashboard/ProfilePage/LeadPreview";
import LoanHistory from "./pages/LoanHistory/LoanHistory";
import LoanDetail from "./pages/LoanHistory/LoanDetail";
import RepayPage from "./pages/Dashboard/ProfilePage/RepayPage";
import BankDetail from "./pages/Dashboard/BankDetail/BankDetail";
import Ghaziabad from "./pages/locations/Ghaziabad";
import Noida from "./pages/locations/Noida";
import Faridabad from "./pages/locations/Faridabad";
import GreaterNoida from "./pages/locations/GreaterNoida";
import Gurgaon from "./pages/locations/Gurgaon";
import RepayThankyou from "./pages/RepayThanku";
import RepaymentStatus from "./pages/RepaymentStatus";
import MainLayout from "./components/MainLayout";
import VideoKycPage from "./pages/VideoKyc/VideoKycPage";
import AccountAggregatorLinkPage from "./pages/AccountAggregatorLink/AccountAggregatorLinkPage";
import CorporateGovernance from "./pages/compliance/CorporateGovernance";
import FairPracticeCode from "./pages/compliance/FairPracticeCode";
import InterestRate from "./pages/compliance/InterestRate";
// import RiskManagement from "./pages/compliance/RiskManagement";
import RegulatoryCompliance from "./pages/compliance/RegulatoryCompliance";

import DocsVerification from "./pages/DocsVerification";
import Login from "./pages/admin/Login";
const showmessage = async (message) => {
  try {
    var x = document.getElementById("snackbar");
    x.className = "show";
    x.innerText = message;
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
  } catch (error) {
    console.log(error);
  }
};

function Router() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* opened from the link a credit manager emails, no login (the signed token in the URL is the credential) */}
        <Route path="/video-kyc/:token" element={<VideoKycPage />} />
        {/* same for sharing the bank statement through Account Aggregator (the link starts one consent) */}
        <Route path="/account-aggregator/:token" element={<AccountAggregatorLinkPage />} />

        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="home" element={<Home />} />
          <Route path="about-us" element={<About />} />
          <Route path="services" element={<Services />} />
            <Route path="contact" element={<Contact />} />
            <Route path="counselling" element={<Counselling />} />

          <Route path="short-term-loan" element={<ShortLoan />} />
          <Route path="instant-loan" element={<InstantLoan />} />
          <Route path="faq" element={<FAQ />} />
          {/* <Route path="rateandterms" element={<RateandTerms />} /> */}
          <Route path="privacypolicy" element={<PrivacyPolicy />} />
          <Route path="termsandconditions" element={<TermsandConditions />} />
          <Route path="docs-verification" element={<DocsVerification />} />
          <Route
            path="Instant-Personal-Loan-for-Salaried-in-Delhi"
            element={<Delhi />}
          />
          <Route
            path="advance-loans-Online-in-Bangalore"
            element={<Banglore />}
          />
          <Route path="loan-agency-in-mumbai" element={<Mumbai />} />
          <Route
            path="instant-personal-loan-in-ahmedabad"
            element={<Ahmedabad />}
          />
          <Route
            path="instant-personal-loan-online-in-hyderabad"
            element={<Hyderabad />}
          />
          <Route path="personal-loan-in-Gurgaon" element={<Gurgaon />} />
          <Route path="Personal-loan-in-Noida" element={<Noida />} />
          <Route path="personal-loan-in-faridabad" element={<Faridabad />} />
          <Route
            path="instant-personal-loan-in-greater-noida"
            element={<GreaterNoida />}
          />
          <Route
            path="Instant-Personal-Loan-in-Ghaziabad"
            element={<Ghaziabad />}
          />
          <Route path="flexibility" element={<Flexibility />} />
          <Route
            path="debt-consolidation-loan"
            element={<DebtConsolidation />}
          />
          <Route path="minimalcommitment" element={<MinimalCommitment />} />
          <Route path="costeffective" element={<CostEffective />} />
          <Route path="thanku" element={<RepayThankyou />} />
          <Route
            path="apply-now"
            element={<ApplyForLoan showmessage={showmessage} />}
          />

          <Route
            path="corporate-governance"
            element={<CorporateGovernance />}
          />
          <Route path="fair-practice-code" element={<FairPracticeCode />} />
          <Route path="interest-rate" element={<InterestRate />} />
          {/* <Route path="risk-management" element={<RiskManagement />} /> */}
          <Route path="regulatory-compliance" element={<RegulatoryCompliance />} />


          <Route
            path="repayloan"
            element={<RepayLoan showmessage={showmessage} />}
          />
          <Route
            path="repayloan/success"
            element={<RepaymentStatus success={true} />}
          />
          <Route
            path="repayloan/failure"
            element={<RepaymentStatus success={false} />}
          />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/reports-details" element={<ReportsDetails />} />
        </Route>

        <Route path="/my-dashboard" element={<LoanLayout />}>
          <Route
            path="/my-dashboard/"
            element={<DashBoard showmessage={showmessage} />}
          />
          <Route path="/my-dashboard/pan-details" element={<PanDetails />} />
          <Route
            path="/my-dashboard/captur-address"
            element={<CapturAddress />}
          />
          <Route
            path="/my-dashboard/captur-personal-information"
            element={<CapturPersonalInformation />}
          />
          <Route
            path="/my-dashboard/captur-income-details"
            element={<CapturIncomeDetails />}
          />
          <Route
            path="/my-dashboard/upload-picture"
            element={<UploadPicture />}
          />
          <Route path="/my-dashboard/user-profile" element={<ProfilePage />} />
          <Route
            path="/my-dashboard/profile-preview"
            element={<ProfilePreview />}
          />
          <Route
            path="/my-dashboard/calculate-loan"
            element={<CalculateLoan />}
          />
          <Route
            path="/my-dashboard/about-your-company"
            element={<AboutCompany />}
          />
          <Route path="/my-dashboard/bank-detail" element={<BankDetail />} />
          <Route path="/my-dashboard/kyc" element={<Ekyc />} />
          <Route
            path="/my-dashboard/bank-upload"
            element={<UploadBankStatement />}
          />
          <Route
            path="/my-dashboard/account-aggregator"
            element={<AccountAggregator />}
          />
          <Route path="/my-dashboard/pan-upload" element={<PanUpload />} />
          <Route
            path="/my-dashboard/adhar-upload"
            element={<DocumentUpload />}
          />

          <Route
            path="/my-dashboard/reference-details"
            element={<ReferenceDetails />}
          />


          <Route path="/my-dashboard/congratulations" element={<ThankYou />} />
          <Route
            path="/my-dashboard/upload-salaryslip"
            element={<UploadSalaryslip />}
          />
          <Route
            path="/my-dashboard/upload-utilitybill"
            element={<UploadUtilitybill />}
          />
          <Route path="/my-dashboard/lead-preview" element={<LeadPreview />} />
          <Route path="/my-dashboard/leads" element={<LoanHistory />} />
          <Route path="/my-dashboard/bureau-request" element={<CIBILRequest />} />
          <Route path="/my-dashboard/bureau-score" element={<BureauScoreDisplay />} />
          <Route path="/my-dashboard/repayment" element={<RepayPage />} />
          <Route path="/my-dashboard/details" element={<LoanDetail />} />
          {/* <Route path="/my-dashboard/eligibility" element={<Eligibility />} /> */}

          <Route
            path="/my-dashboard/eligibility"
            element={
              <ProtectedRoute
                redirectTo="/my-dashboard"
                element={<Eligibility />}
              />
            }
          />
        </Route>
      </Routes>
    </>
  );
}

export default Router;
